import httpClient from './http-client';

const endpoint = 'api/pages';

const pagesService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (page) => httpClient.post(`${endpoint}`, page),

  update: (page) => httpClient.put(`${endpoint}/${page.id}`, page),

  delete: (page) => httpClient.delete(`${endpoint}/${page.id}`),
};

export default pagesService;
